import { HomeAttendanceTeacher } from './HomeAttendanceTeacher';
export default HomeAttendanceTeacher;
